<template>
  <div>
    <div v-if="f_field.headline">
      <!-- <h1>{{f_field.title}}</h1>
      <v-divider inset></v-divider> -->
    </div>
    <div v-else>
      <v-container grid-list-md v-if="value_calculated_empty">
          <div v-if="f_field.ctype=='text-short'">
            <v-layout row wrap>
              <v-flex d-flex xs3 text-xs-right dark>{{f_field.title}}</v-flex>
              <v-flex d-flex xs9 text-xs-left v-html="value_calculated">
                <!-- <div class="body-2 ml-3" v-if="field.type='text-short'" v-html="value_calculated" ></div> -->
              </v-flex>
            </v-layout>
          </div>
          <div v-else-if="f_field.ctype=='text-long'">
            <v-layout row wrap>
              <v-flex xs12 text-xs-left>
                <div >{{f_field.title}}</div>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 text-xs-left v-html="value_calculated"></v-flex>
            </v-layout>
          </div>
          <div v-else-if="f_field.ctype=='date'">
            <v-layout row wrap>
              <v-flex d-flex xs3 text-xs-right dark>{{f_field.title}}</v-flex>
              <v-flex d-flex xs9 text-xs-left v-html="format_date(value_calculated,f_field.format)"></v-flex>
            </v-layout>
          </div>
          <div v-else-if="f_field.ctype=='bool'">
            <v-layout row wrap>
              <v-flex d-flex xs3 text-xs-right dark>{{f_field.title}}</v-flex>
              <v-flex d-flex xs9 text-xs-left v-html="value_from_array"></v-flex>
            </v-layout>
          </div>
      </v-container>
    </div>
      <!-- <v-list-tile-title v-if="field.type='text-long'" >            <v-card-text>{{ value_calculated }}</v-card-text>        </v-list-tile-title> -->
  </div>
</template>

<script>
// import moment from 'moment'

function nl2br (str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
}

export default {
  data () {
    return {
      f_field: this.field,
      f_artist: this.artist,
      f_artwork: this.artwork,
      item: {
        title: 'Artist',
        value: 'Artist name'
      }
    }
  },
  props: ['field','artist','artwork'],
  methods: {
    format_date (date,format) {
      var moment = require('moment')
      var ndate = new Date(date)
      return moment(ndate).format(format)
      // console.log(ndate)
    }
  },
  computed: {
    value_calculated () {
      let output = ''
      switch (this.f_field.table) {
        case 'artists':
          if (this.f_field.name)
            output = nl2br(this.f_artist[this.field.name])
          else
            output = 'no artist name entered in cms'
          break
        case 'artwork_locations':
          output = nl2br(this.f_artwork[this.f_field.association][this.f_field.name])
          break
        case 'contacts':
          output = nl2br(this.f_artwork[this.f_field.association][this.f_field.name])
          break
        default:
          output = nl2br(this.f_artwork[this.f_field.name])
          if (this.f_field.suffix) {
            output += this.f_field.suffix
          }
      }
      return output
    },
    value_from_array () {
      let v = this.value_calculated
      return this.f_field.options[v]
    },
    value_calculated_empty () {
      let output = ''
      switch (this.f_field.table) {
        case 'artists':
          if (typeof this.f_artist !== 'undefined') {
            output = this.f_artist[this.f_field.name]
          } else {
            output = ''
          } 
          break
        case 'artwork_locations':
          if (typeof this.f_artwork[this.f_field.association] !== 'undefined') {
            output = this.f_artwork[this.f_field.association][this.f_field.name]
          } else {
            output = ''
          }
          break
        case 'contacts':
          if (typeof this.f_artwork[this.f_field.association] !== 'undefined') {
            output = (this.f_artwork[this.f_field.association][this.f_field.name])
          } else {
            output = ''
          } 
          break
        default:
          output = this.f_artwork[this.f_field.name]
      }
      let o=false
      if (output=='' || output==undefined || output==null) {
        o = false
      } else {
        o = true
      }
      return o
    }    
  }
}

</script>

<style scoped>
  li {list-style:none; margin: 15px 0;}
</style>



// WEBPACK FOOTER //
// src/components/artworks/FieldBox.vue